import styled from 'styled-components';
import { v2Breakpoints } from './styles/tokens';

// "Residenza" + "Codice Postale" sit side by side on wider screens and stack
// on mobile, where cramming both into one row squeezed the react-select value
// area down to a couple of characters.
export const ResidenceRow = styled.div`
  display: flex;
  align-items: flex-start;
  column-gap: 20px;

  > .residence-field {
    flex: 2;
    min-width: 0;
  }

  > .residence-postal {
    flex: 1;
    flex-basis: 50px;
  }

  @media (max-width: ${v2Breakpoints.tablet}) {
    flex-direction: column;
    column-gap: 0;

    > .residence-field,
    > .residence-postal {
      flex: 1 1 auto;
      width: 100%;
    }
  }
`;
